<template>
  <div>
    <div class="blockcont">
      <ul class="itemlisttable">
        <li class="item-block itemlisthead">
          <div class="item-date"><b>Date</b></div>
          <div class="item-doctor"><b>Doctor</b></div>
          <div class="item-type"><b>Type</b></div>
          <div class="item-kind"><b>Action</b></div>
          <div class="item-dea"><b>Dea</b></div>
          <div class="item-user"><b>User</b></div>
        </li>
        <li v-for="item in histories" :key="item._id" class="list-item">
          <div class="item-date">{{ formatFullTime12Hour(item.createdAt) }}</div>
          <div class="item-doctor">{{ item.doctorName }}</div>
          <div class="item-type">{{ getTypeName(item) }}</div>
          <div class="item-kind">
            {{ getKindName(item) }}
            <div class="item-decline-reason" :title="item.declineReason" v-if="item.kind === 'decline'">
              ({{item.declineReason}})
            </div>
          </div>
          <div class="item-dea">{{ item.user ? item.user.dea : 'N/A' }}</div>
          <div class="item-user">{{ item.user ? item.user.fullName : 'N/A' }}</div>
        </li>
      </ul>
    </div>
    <pagination :currentPage="paginate.page" :perPage="paginate.perPage" :total="paginate.total"
                :totalPages="paginate.totalPages" @updatePerPage="updatePerPage"></pagination>
  </div>
</template>
<script>
import Pagination from '@/global/Pagination.vue'
import CommonMixin from '@/mixins/general/CommonMixin.vue'
import httpClient from '@/client'

export default {
  name: 'HistoryApprovalEpcs',
  components: { Pagination },
  props: {
    doctor: {}
  },
  mixins: [CommonMixin],
  data () {
    return {
      histories: [],
      paginate: {
        perPage: 10,
        page: 1,
        totalPages: 10,
        total: 0
      }
    }
  },
  computed: {},
  watch: {},
  updated () {
  },
  created () {
    this.getListHistories()
  },
  beforeDestroy () {
  },
  methods: {
    getKindName (item) {
      if (item.kind === 'approval') {
        let array = ['First', 'Second']
        return `${array[item.order - 1]} approval`
      }
      if (item.kind === 'decline') {
        return 'Declined'
      }
      return 'Created'
    },
    getTypeName (item) {
      return `${item.action === 'add' ? 'Add' : 'Remove'} Controlled Substance`
    },
    updatePerPage (data) {
      this.paginate.perPage = data.perPage
      this.paginate.page = data.currentPage
      this.getListHistories()
    },
    async getListHistories () {
      try {
        let params = {
          page: this.paginate.page,
          perPage: this.paginate.perPage
        }
        const response = await httpClient.get(`/surescript/approval-request-histories/${this.doctor.id}`, { params })
        if (response.data.s === 200) {
          this.histories = response.data.data.histories.data ? response.data.data.histories.data : []
          this.paginate.page = Number(response.data.data.histories.currentPage)
          this.paginate.total = response.data.data.histories.total
          this.paginate.totalPages = Math.ceil(this.paginate.total / this.paginate.perPage)
        } else {
          this.alertError(response.data.msg)
        }
      } catch (e) {
        this.alertException(e)
      }
    }
  }
}
</script>
<style scoped>
.item-block {
  display: block;
  width: 100% !important;
  clear: both;
}

.item-date {
  width: 15% !important;
  float: left;
  display: block;
  min-height: 1px;
}

.item-doctor {
  width: 20% !important;
  float: left;
  display: block;
  min-height: 1px;
}

.item-kind {
  width: 20% !important;
  float: left;
  display: block;
  min-height: 1px;
  text-align: left !important;
}
.item-type {
  width: 15% !important;
  float: left;
  display: block;
  min-height: 1px;
  text-align: left !important;
}

.item-dea {
  width: 15% !important;
  float: left;
  display: block;
  min-height: 1px;
}

.item-user {
  width: 15% !important;
  float: left;
  display: block;
  min-height: 1px;
}
.item-decline-reason {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 100%;
}
</style>
